module.exports = __webpack_public_path__ + "img/Visiapp.bb0c170d.jpg";